import { useQuery } from "react-query";
import { getUsers } from "~/components/Forms/UsersForm/rolesRequest/getUsers";

export default function useGetUsers(id: string) {
  return useQuery({
    queryKey: ["getUsers", id],
    queryFn: () => getUsers(id),
    refetchOnWindowFocus: false,
    cacheTime: 0,
    enabled: !!id,
    onSuccess: (data) => {
      console.log("useGetRole success:", data);
    },
    onError: (error) => {
      console.error("useGetRole error:", error);
    },
  });
}
